import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation(['aboutUs']);
  return (
    <>
      {/* <div className="!bg-white px-6 pb-12 sm:px-16 h-[45vh] pt-10 text-2xl text-gray-400">{t('aboutUsComingSoon')} ...</div> */}
    
    <div className="!bg-white px-6 pb-12 sm:px-16">
      <section className="mb-12 mt-12 w-full">
        <h1 className="text-[48px] text-headings-font-color sm:text-[64px]">{t('pageHeading')}</h1>
        <p className="text-base font-medium text-font-color">{t('pageDescription')}</p>
      </section>

      <section className="my-8">
        <h3 className="mb-2 text-[32px] text-headings-font-color">{t('whoWeAre')}</h3>
        <p>
          {t('whoWeAreDescription1')}
        </p>
        <br />
        <p>
          {t('whoWeAreDescription2')}
        </p>
      </section>

      <section className="my-8">
        <h3 className="mb-2 text-[32px] text-headings-font-color">{t('howWeWork')}</h3>
        <p>
          {t('howWeWorkDescription')}
        </p>
      </section>

      <section className="my-8">
        <h3 className="mb-2 text-[32px] text-headings-font-color">{t('mission')}</h3>
        <p>
          {t('missionDescription')}
        </p>
      </section>
      <section className="my-8">
        <h3 className="mb-2 text-[32px] text-headings-font-color">{t('vision')}</h3>
        <p>
          {t('visionDescription')}
        </p>
      </section>
    </div>
    </>    
  );
};

export default AboutUs;
